export const countries = [
  {
    "name": "Russia",
    "code": "RU",
    "flag": "🇷🇺",
    "native": "Россия",
    "russian": "Россия",
    "phone": [
      7
    ],
    "continent": "EU",
    "continents": [
      "AS",
      "EU"
    ],
    "capital": "Moscow",
    "currency": [
      "RUB"
    ],
    "languages": [
      "ru"
    ],
    "both": "Russia (Россия)"
  },
  {
    "name": "Portugal",
    "code": "PT",
    "flag": "🇵🇹",
    "native": "Portugal",
    "russian": "Португалия",
    "phone": [
      351
    ],
    "continent": "EU",
    "capital": "Lisbon",
    "currency": [
      "EUR"
    ],
    "languages": [
      "pt"
    ],
    "both": "Portugal (Portugal)"
  },
  {
    "name": "Belarus",
    "code": "BY",
    "flag": "🇧🇾",
    "native": "Белару́сь",
    "russian": "Беларусь",
    "phone": [
      375
    ],
    "continent": "EU",
    "capital": "Minsk",
    "currency": [
      "BYN"
    ],
    "languages": [
      "be",
      "ru"
    ],
    "both": "Belarus (Белару́сь)"
  },
  {
    "name": "Kazakhstan",
    "code": "KZ",
    "flag": "🇰🇿",
    "native": "Қазақстан",
    "russian": "Казахстан",
    "phone": [
      76,
      77
    ],
    "continent": "AS",
    "continents": [
      "AS",
      "EU"
    ],
    "capital": "Astana",
    "currency": [
      "KZT"
    ],
    "languages": [
      "kk",
      "ru"
    ],
    "both": "Kazakhstan (Қазақстан)"
  },
  {
    "name": "Germany",
    "code": "DE",
    "flag": "🇩🇪",
    "native": "Deutschland",
    "russian": "Германия",
    "phone": [
      49
    ],
    "continent": "EU",
    "capital": "Berlin",
    "currency": [
      "EUR"
    ],
    "languages": [
      "de"
    ],
    "both": "Germany (Deutschland)"
  },
  {
    "name": "Andorra",
    "code": "AD",
    "flag": "🇦🇩",
    "native": "Andorra",
    "russian": "Андорра",
    "phone": [
      376
    ],
    "continent": "EU",
    "capital": "Andorra la Vella",
    "currency": [
      "EUR"
    ],
    "languages": [
      "ca"
    ],
    "both": "Andorra (Andorra)"
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "flag": "🇦🇪",
    "native": "دولة الإمارات العربية المتحدة",
    "russian": "Объединённые Арабские Эмираты",
    "phone": [
      971
    ],
    "continent": "AS",
    "capital": "Abu Dhabi",
    "currency": [
      "AED"
    ],
    "languages": [
      "ar"
    ],
    "both": "United Arab Emirates (دولة الإمارات العربية المتحدة)"
  },
  {
    "name": "Afghanistan",
    "code": "AF",
    "flag": "🇦🇫",
    "native": "افغانستان",
    "russian": "Афганистан",
    "phone": [
      93
    ],
    "continent": "AS",
    "capital": "Kabul",
    "currency": [
      "AFN"
    ],
    "languages": [
      "ps",
      "uz",
      "tk"
    ],
    "both": "Afghanistan (افغانستان)"
  },
  {
    "name": "Antigua and Barbuda",
    "code": "AG",
    "flag": "🇦🇬",
    "native": "Antigua and Barbuda",
    "russian": "Антигуа и Барбуда",
    "phone": [
      1268
    ],
    "continent": "NA",
    "capital": "Saint John's",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Antigua and Barbuda (Antigua and Barbuda)"
  },
  {
    "name": "Abkhazia",
    "code": "AB",
    "flag": "🏴",
    "native": "Республика Абхазия",
    "russian": "Абхазия",
    "phone": [
      7
    ],
    "continent": "NA",
    "capital": "Saint John's",
    "currency": [
      "RUB"
    ],
    "languages": [
      "ru"
    ],
    "both": "Abkhazia (Республика Абхазия)"
  },
  {
    "name": "Anguilla",
    "code": "AI",
    "flag": "🇦🇮",
    "native": "Anguilla",
    "russian": "Ангилья",
    "phone": [
      1264
    ],
    "continent": "NA",
    "capital": "The Valley",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Anguilla (Anguilla)"
  },
  {
    "name": "Albania",
    "code": "AL",
    "flag": "🇦🇱",
    "native": "Shqipëria",
    "russian": "Албания",
    "phone": [
      355
    ],
    "continent": "EU",
    "capital": "Tirana",
    "currency": [
      "ALL"
    ],
    "languages": [
      "sq"
    ],
    "both": "Albania (Shqipëria)"
  },
  {
    "name": "Armenia",
    "code": "AM",
    "flag": "🇦🇲",
    "native": "Հայաստան",
    "russian": "Армения",
    "phone": [
      374
    ],
    "continent": "AS",
    "capital": "Yerevan",
    "currency": [
      "AMD"
    ],
    "languages": [
      "hy",
      "ru"
    ],
    "both": "Armenia (Հայաստան)"
  },
  {
    "name": "Angola",
    "code": "AO",
    "flag": "🇦🇴",
    "native": "Angola",
    "russian": "Ангола",
    "phone": [
      244
    ],
    "continent": "AF",
    "capital": "Luanda",
    "currency": [
      "AOA"
    ],
    "languages": [
      "pt"
    ],
    "both": "Angola (Angola)"
  },
  {
    "name": "Antarctica",
    "code": "AQ",
    "flag": "🇦🇶",
    "native": "Antarctica",
    "russian": "Антарктида",
    "phone": [
      672
    ],
    "continent": "AN",
    "capital": "",
    "currency": [

    ],
    "languages": [

    ],
    "both": "Antarctica (Antarctica)"
  },
  {
    "name": "Argentina",
    "code": "AR",
    "flag": "🇦🇷",
    "native": "Argentina",
    "russian": "Аргентина",
    "phone": [
      54
    ],
    "continent": "SA",
    "capital": "Buenos Aires",
    "currency": [
      "ARS"
    ],
    "languages": [
      "es",
      "gn"
    ],
    "both": "Argentina (Argentina)"
  },
  {
    "name": "American Samoa",
    "code": "AS",
    "flag": "🇦🇸",
    "native": "American Samoa",
    "russian": "Американское Самоа",
    "phone": [
      1684
    ],
    "continent": "OC",
    "capital": "Pago Pago",
    "currency": [
      "USD"
    ],
    "languages": [
      "en",
      "sm"
    ],
    "both": "American Samoa (American Samoa)"
  },
  {
    "name": "Austria",
    "code": "AT",
    "flag": "🇦🇹",
    "native": "Österreich",
    "russian": "Австрия",
    "phone": [
      43
    ],
    "continent": "EU",
    "capital": "Vienna",
    "currency": [
      "EUR"
    ],
    "languages": [
      "de"
    ],
    "both": "Austria (Österreich)"
  },
  {
    "name": "Australia",
    "code": "AU",
    "flag": "🇦🇺",
    "native": "Australia",
    "russian": "Австралия",
    "phone": [
      61
    ],
    "continent": "OC",
    "capital": "Canberra",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Australia (Australia)"
  },
  {
    "name": "Aruba",
    "code": "AW",
    "flag": "🇦🇼",
    "native": "Aruba",
    "russian": "Аруба",
    "phone": [
      297
    ],
    "continent": "NA",
    "capital": "Oranjestad",
    "currency": [
      "AWG"
    ],
    "languages": [
      "nl",
      "pa"
    ],
    "both": "Aruba (Aruba)"
  },
  {
    "name": "Åland",
    "code": "AX",
    "flag": "🇦🇽",
    "native": "Åland",
    "russian": "Аландские острова",
    "phone": [
      358
    ],
    "continent": "EU",
    "capital": "Mariehamn",
    "currency": [
      "EUR"
    ],
    "languages": [
      "sv"
    ],
    "both": "Åland (Åland)"
  },
  {
    "name": "Azerbaijan",
    "code": "AZ",
    "flag": "🇦🇿",
    "native": "Azərbaycan",
    "russian": "Азербайджан",
    "phone": [
      994
    ],
    "continent": "AS",
    "continents": [
      "AS",
      "EU"
    ],
    "capital": "Baku",
    "currency": [
      "AZN"
    ],
    "languages": [
      "az"
    ],
    "both": "Azerbaijan (Azərbaycan)"
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BA",
    "flag": "🇧🇦",
    "native": "Bosna i Hercegovina",
    "russian": "Босния и Герцеговина",
    "phone": [
      387
    ],
    "continent": "EU",
    "capital": "Sarajevo",
    "currency": [
      "BAM"
    ],
    "languages": [
      "bs",
      "hr",
      "sr"
    ],
    "both": "Bosnia and Herzegovina (Bosna i Hercegovina)"
  },
  {
    "name": "Barbados",
    "code": "BB",
    "flag": "🇧🇧",
    "native": "Barbados",
    "russian": "Барбадос",
    "phone": [
      1246
    ],
    "continent": "NA",
    "capital": "Bridgetown",
    "currency": [
      "BBD"
    ],
    "languages": [
      "en"
    ],
    "both": "Barbados (Barbados)"
  },
  {
    "name": "Bangladesh",
    "code": "BD",
    "flag": "🇧🇩",
    "native": "Bangladesh",
    "russian": "Бангладеш",
    "phone": [
      880
    ],
    "continent": "AS",
    "capital": "Dhaka",
    "currency": [
      "BDT"
    ],
    "languages": [
      "bn"
    ],
    "both": "Bangladesh (Bangladesh)"
  },
  {
    "name": "Belgium",
    "code": "BE",
    "flag": "🇧🇪",
    "native": "België",
    "russian": "Бельгия",
    "phone": [
      32
    ],
    "continent": "EU",
    "capital": "Brussels",
    "currency": [
      "EUR"
    ],
    "languages": [
      "nl",
      "fr",
      "de"
    ],
    "both": "Belgium (België)"
  },
  {
    "name": "Burkina Faso",
    "code": "BF",
    "flag": "🇧🇫",
    "native": "Burkina Faso",
    "russian": "Буркина-Фасо",
    "phone": [
      226
    ],
    "continent": "AF",
    "capital": "Ouagadougou",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr",
      "ff"
    ],
    "both": "Burkina Faso (Burkina Faso)"
  },
  {
    "name": "Bulgaria",
    "code": "BG",
    "flag": "🇧🇬",
    "native": "България",
    "russian": "Болгария",
    "phone": [
      359
    ],
    "continent": "EU",
    "capital": "Sofia",
    "currency": [
      "BGN"
    ],
    "languages": [
      "bg"
    ],
    "both": "Bulgaria (България)"
  },
  {
    "name": "Bahrain",
    "code": "BH",
    "flag": "🇧🇭",
    "native": "‏البحرين",
    "russian": "Бахрейн",
    "phone": [
      973
    ],
    "continent": "AS",
    "capital": "Manama",
    "currency": [
      "BHD"
    ],
    "languages": [
      "ar"
    ],
    "both": "Bahrain (‏البحرين)"
  },
  {
    "name": "Burundi",
    "code": "BI",
    "flag": "🇧🇮",
    "native": "Burundi",
    "russian": "Бурунди",
    "phone": [
      257
    ],
    "continent": "AF",
    "capital": "Bujumbura",
    "currency": [
      "BIF"
    ],
    "languages": [
      "fr",
      "rn"
    ],
    "both": "Burundi (Burundi)"
  },
  {
    "name": "Benin",
    "code": "BJ",
    "flag": "🇧🇯",
    "native": "Bénin",
    "russian": "Бенин",
    "phone": [
      229
    ],
    "continent": "AF",
    "capital": "Porto-Novo",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Benin (Bénin)"
  },
  {
    "name": "Saint Barthélemy",
    "code": "BL",
    "flag": "🇧🇱",
    "native": "Saint-Barthélemy",
    "russian": "Сен-Бартелеми",
    "phone": [
      590
    ],
    "continent": "NA",
    "capital": "Gustavia",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Saint Barthélemy (Saint-Barthélemy)"
  },
  {
    "name": "Bermuda",
    "code": "BM",
    "flag": "🇧🇲",
    "native": "Bermuda",
    "russian": "Бермуды",
    "phone": [
      1441
    ],
    "continent": "NA",
    "capital": "Hamilton",
    "currency": [
      "BMD"
    ],
    "languages": [
      "en"
    ],
    "both": "Bermuda (Bermuda)"
  },
  {
    "name": "Brunei",
    "code": "BN",
    "flag": "🇧🇳",
    "native": "Negara Brunei Darussalam",
    "russian": "Бруней",
    "phone": [
      673
    ],
    "continent": "AS",
    "capital": "Bandar Seri Begawan",
    "currency": [
      "BND"
    ],
    "languages": [
      "ms"
    ],
    "both": "Brunei (Negara Brunei Darussalam)"
  },
  {
    "name": "Bolivia",
    "code": "BO",
    "flag": "🇧🇴",
    "native": "Bolivia",
    "russian": "Боливия",
    "phone": [
      591
    ],
    "continent": "SA",
    "capital": "Sucre",
    "currency": [
      "BOB",
      "BOV"
    ],
    "languages": [
      "es",
      "ay",
      "qu"
    ],
    "both": "Bolivia (Bolivia)"
  },
  {
    "name": "Bonaire",
    "code": "BQ",
    "flag": "🇧🇶",
    "native": "Bonaire",
    "russian": "Бонэйр",
    "phone": [
      5997
    ],
    "continent": "NA",
    "capital": "Kralendijk",
    "currency": [
      "USD"
    ],
    "languages": [
      "nl"
    ],
    "both": "Bonaire (Bonaire)"
  },
  {
    "name": "Brazil",
    "code": "BR",
    "flag": "🇧🇷",
    "native": "Brasil",
    "russian": "Бразилия",
    "phone": [
      55
    ],
    "continent": "SA",
    "capital": "Brasília",
    "currency": [
      "BRL"
    ],
    "languages": [
      "pt"
    ],
    "both": "Brazil (Brasil)"
  },
  {
    "name": "Bahamas",
    "code": "BS",
    "flag": "🇧🇸",
    "native": "Bahamas",
    "russian": "Багамы",
    "phone": [
      1242
    ],
    "continent": "NA",
    "capital": "Nassau",
    "currency": [
      "BSD"
    ],
    "languages": [
      "en"
    ],
    "both": "Bahamas (Bahamas)"
  },
  {
    "name": "Bhutan",
    "code": "BT",
    "flag": "🇧🇹",
    "native": "ʼbrug-yul",
    "russian": "Бутан",
    "phone": [
      975
    ],
    "continent": "AS",
    "capital": "Thimphu",
    "currency": [
      "BTN",
      "INR"
    ],
    "languages": [
      "dz"
    ],
    "both": "Bhutan (ʼbrug-yul)"
  },
  {
    "name": "Bouvet Island",
    "code": "BV",
    "flag": "🇧🇻",
    "native": "Bouvetøya",
    "russian": "Остров Буве",
    "phone": [
      47
    ],
    "continent": "AN",
    "capital": "",
    "currency": [
      "NOK"
    ],
    "languages": [
      "no",
      "nb",
      "nn"
    ],
    "both": "Bouvet Island (Bouvetøya)"
  },
  {
    "name": "Botswana",
    "code": "BW",
    "flag": "🇧🇼",
    "native": "Botswana",
    "russian": "Ботсвана",
    "phone": [
      267
    ],
    "continent": "AF",
    "capital": "Gaborone",
    "currency": [
      "BWP"
    ],
    "languages": [
      "en",
      "tn"
    ],
    "both": "Botswana (Botswana)"
  },
  {
    "name": "Belize",
    "code": "BZ",
    "flag": "🇧🇿",
    "native": "Belize",
    "russian": "Белиз",
    "phone": [
      501
    ],
    "continent": "NA",
    "capital": "Belmopan",
    "currency": [
      "BZD"
    ],
    "languages": [
      "en",
      "es"
    ],
    "both": "Belize (Belize)"
  },
  {
    "name": "Canada",
    "code": "CA",
    "flag": "🇨🇦",
    "native": "Canada",
    "russian": "Канада",
    "phone": [
      1
    ],
    "continent": "NA",
    "capital": "Ottawa",
    "currency": [
      "CAD"
    ],
    "languages": [
      "en",
      "fr"
    ],
    "both": "Canada (Canada)"
  },
  {
    "name": "Cocos [Keeling] Islands",
    "code": "CC",
    "flag": "🇨🇨",
    "native": "Cocos (Keeling) Islands",
    "russian": "Кокосовые острова",
    "phone": [
      61
    ],
    "continent": "AS",
    "capital": "West Island",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Cocos [Keeling] Islands (Cocos (Keeling) Islands)"
  },
  {
    "name": "Democratic Republic of the Congo",
    "code": "CD",
    "flag": "🇨🇩",
    "native": "République démocratique du Congo",
    "russian": "Демократическая Республика Конго",
    "phone": [
      243
    ],
    "continent": "AF",
    "capital": "Kinshasa",
    "currency": [
      "CDF"
    ],
    "languages": [
      "fr",
      "ln",
      "kg",
      "sw",
      "lu"
    ],
    "both": "Democratic Republic of the Congo (République démocratique du Congo)"
  },
  {
    "name": "Central African Republic",
    "code": "CF",
    "flag": "🇨🇫",
    "native": "Ködörösêse tî Bêafrîka",
    "russian": "Центральноафриканская Республика",
    "phone": [
      236
    ],
    "continent": "AF",
    "capital": "Bangui",
    "currency": [
      "XAF"
    ],
    "languages": [
      "fr",
      "sg"
    ],
    "both": "Central African Republic (Ködörösêse tî Bêafrîka)"
  },
  {
    "name": "Republic of the Congo",
    "code": "CG",
    "flag": "🇨🇬",
    "native": "République du Congo",
    "russian": "Республика Конго",
    "phone": [
      242
    ],
    "continent": "AF",
    "capital": "Brazzaville",
    "currency": [
      "XAF"
    ],
    "languages": [
      "fr",
      "ln"
    ],
    "both": "Republic of the Congo (République du Congo)"
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "flag": "🇨🇭",
    "native": "Schweiz",
    "russian": "Швейцария",
    "phone": [
      41
    ],
    "continent": "EU",
    "capital": "Bern",
    "currency": [
      "CHE",
      "CHF",
      "CHW"
    ],
    "languages": [
      "de",
      "fr",
      "it"
    ],
    "both": "Switzerland (Schweiz)"
  },
  {
    "name": "Ivory Coast",
    "code": "CI",
    "flag": "🇨🇮",
    "native": "Côte d'Ivoire",
    "russian": "Кот-д'Ивуар",
    "phone": [
      225
    ],
    "continent": "AF",
    "capital": "Yamoussoukro",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Ivory Coast (Côte d'Ivoire)"
  },
  {
    "name": "Cook Islands",
    "code": "CK",
    "flag": "🇨🇰",
    "native": "Cook Islands",
    "russian": "Острова Кука",
    "phone": [
      682
    ],
    "continent": "OC",
    "capital": "Avarua",
    "currency": [
      "NZD"
    ],
    "languages": [
      "en"
    ],
    "both": "Cook Islands (Cook Islands)"
  },
  {
    "name": "Chile",
    "code": "CL",
    "flag": "🇨🇱",
    "native": "Chile",
    "russian": "Чили",
    "phone": [
      56
    ],
    "continent": "SA",
    "capital": "Santiago",
    "currency": [
      "CLF",
      "CLP"
    ],
    "languages": [
      "es"
    ],
    "both": "Chile (Chile)"
  },
  {
    "name": "Cameroon",
    "code": "CM",
    "flag": "🇨🇲",
    "native": "Cameroon",
    "russian": "Камерун",
    "phone": [
      237
    ],
    "continent": "AF",
    "capital": "Yaoundé",
    "currency": [
      "XAF"
    ],
    "languages": [
      "en",
      "fr"
    ],
    "both": "Cameroon (Cameroon)"
  },
  {
    "name": "China",
    "code": "CN",
    "flag": "🇨🇳",
    "native": "中国",
    "russian": "Китай",
    "phone": [
      86
    ],
    "continent": "AS",
    "capital": "Beijing",
    "currency": [
      "CNY"
    ],
    "languages": [
      "zh"
    ],
    "both": "China (中国)"
  },
  {
    "name": "Colombia",
    "code": "CO",
    "flag": "🇨🇴",
    "native": "Colombia",
    "russian": "Колумбия",
    "phone": [
      57
    ],
    "continent": "SA",
    "capital": "Bogotá",
    "currency": [
      "COP"
    ],
    "languages": [
      "es"
    ],
    "both": "Colombia (Colombia)"
  },
  {
    "name": "Costa Rica",
    "code": "CR",
    "flag": "🇨🇷",
    "native": "Costa Rica",
    "russian": "Коста-Рика",
    "phone": [
      506
    ],
    "continent": "NA",
    "capital": "San José",
    "currency": [
      "CRC"
    ],
    "languages": [
      "es"
    ],
    "both": "Costa Rica (Costa Rica)"
  },
  {
    "name": "Cuba",
    "code": "CU",
    "flag": "🇨🇺",
    "native": "Cuba",
    "russian": "Куба",
    "phone": [
      53
    ],
    "continent": "NA",
    "capital": "Havana",
    "currency": [
      "CUC",
      "CUP"
    ],
    "languages": [
      "es"
    ],
    "both": "Cuba (Cuba)"
  },
  {
    "name": "Cape Verde",
    "code": "CV",
    "flag": "🇨🇻",
    "native": "Cabo Verde",
    "russian": "Кабо-Верде",
    "phone": [
      238
    ],
    "continent": "AF",
    "capital": "Praia",
    "currency": [
      "CVE"
    ],
    "languages": [
      "pt"
    ],
    "both": "Cape Verde (Cabo Verde)"
  },
  {
    "name": "Curacao",
    "code": "CW",
    "flag": "🇨🇼",
    "native": "Curaçao",
    "russian": "Кюрасао",
    "phone": [
      5999
    ],
    "continent": "NA",
    "capital": "Willemstad",
    "currency": [
      "ANG"
    ],
    "languages": [
      "nl",
      "pa",
      "en"
    ],
    "both": "Curacao (Curaçao)"
  },
  {
    "name": "Christmas Island",
    "code": "CX",
    "flag": "🇨🇽",
    "native": "Christmas Island",
    "russian": "Остров Рождества",
    "phone": [
      61
    ],
    "continent": "AS",
    "capital": "Flying Fish Cove",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Christmas Island (Christmas Island)"
  },
  {
    "name": "Cyprus",
    "code": "CY",
    "flag": "🇨🇾",
    "native": "Κύπρος",
    "russian": "Кипр",
    "phone": [
      357
    ],
    "continent": "EU",
    "capital": "Nicosia",
    "currency": [
      "EUR"
    ],
    "languages": [
      "el",
      "tr",
      "hy"
    ],
    "both": "Cyprus (Κύπρος)"
  },
  {
    "name": "Czech Republic",
    "code": "CZ",
    "flag": "🇨🇿",
    "native": "Česká republika",
    "russian": "Чехия",
    "phone": [
      420
    ],
    "continent": "EU",
    "capital": "Prague",
    "currency": [
      "CZK"
    ],
    "languages": [
      "cs",
      "sk"
    ],
    "both": "Czech Republic (Česká republika)"
  },
  {
    "name": "Djibouti",
    "code": "DJ",
    "flag": "🇩🇯",
    "native": "Djibouti",
    "russian": "Джибути",
    "phone": [
      253
    ],
    "continent": "AF",
    "capital": "Djibouti",
    "currency": [
      "DJF"
    ],
    "languages": [
      "fr",
      "ar"
    ],
    "both": "Djibouti (Djibouti)"
  },
  {
    "name": "Denmark",
    "code": "DK",
    "flag": "🇩🇰",
    "native": "Danmark",
    "russian": "Дания",
    "phone": [
      45
    ],
    "continent": "EU",
    "continents": [
      "EU",
      "NA"
    ],
    "capital": "Copenhagen",
    "currency": [
      "DKK"
    ],
    "languages": [
      "da"
    ],
    "both": "Denmark (Danmark)"
  },
  {
    "name": "Dominica",
    "code": "DM",
    "flag": "🇩🇲",
    "native": "Dominica",
    "russian": "Доминика",
    "phone": [
      1767
    ],
    "continent": "NA",
    "capital": "Roseau",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Dominica (Dominica)"
  },
  {
    "name": "Dominican Republic",
    "code": "DO",
    "flag": "🇩🇴",
    "native": "República Dominicana",
    "russian": "Доминиканская Республика",
    "phone": [
      1809,
      1829,
      1849
    ],
    "continent": "NA",
    "capital": "Santo Domingo",
    "currency": [
      "DOP"
    ],
    "languages": [
      "es"
    ],
    "both": "Dominican Republic (República Dominicana)"
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "flag": "🇩🇿",
    "native": "الجزائر",
    "russian": "Алжир",
    "phone": [
      213
    ],
    "continent": "AF",
    "capital": "Algiers",
    "currency": [
      "DZD"
    ],
    "languages": [
      "ar"
    ],
    "both": "Algeria (الجزائر)"
  },
  {
    "name": "Ecuador",
    "code": "EC",
    "flag": "🇪🇨",
    "native": "Ecuador",
    "russian": "Эквадор",
    "phone": [
      593
    ],
    "continent": "SA",
    "capital": "Quito",
    "currency": [
      "USD"
    ],
    "languages": [
      "es"
    ],
    "both": "Ecuador (Ecuador)"
  },
  {
    "name": "Estonia",
    "code": "EE",
    "flag": "🇪🇪",
    "native": "Eesti",
    "russian": "Эстония",
    "phone": [
      372
    ],
    "continent": "EU",
    "capital": "Tallinn",
    "currency": [
      "EUR"
    ],
    "languages": [
      "et"
    ],
    "both": "Estonia (Eesti)"
  },
  {
    "name": "Egypt",
    "code": "EG",
    "flag": "🇪🇬",
    "native": "مصر‎",
    "russian": "Египет",
    "phone": [
      20
    ],
    "continent": "AF",
    "continents": [
      "AF",
      "AS"
    ],
    "capital": "Cairo",
    "currency": [
      "EGP"
    ],
    "languages": [
      "ar"
    ],
    "both": "Egypt (مصر‎)"
  },
  {
    "name": "Western Sahara",
    "code": "EH",
    "flag": "🇪🇭",
    "native": "الصحراء الغربية",
    "russian": "Западная Сахара",
    "phone": [
      212
    ],
    "continent": "AF",
    "capital": "El Aaiún",
    "currency": [
      "MAD",
      "DZD",
      "MRU"
    ],
    "languages": [
      "es"
    ],
    "both": "Western Sahara (الصحراء الغربية)"
  },
  {
    "name": "Eritrea",
    "code": "ER",
    "flag": "🇪🇷",
    "native": "ኤርትራ",
    "russian": "Эритрея",
    "phone": [
      291
    ],
    "continent": "AF",
    "capital": "Asmara",
    "currency": [
      "ERN"
    ],
    "languages": [
      "ti",
      "ar",
      "en"
    ],
    "both": "Eritrea (ኤርትራ)"
  },
  {
    "name": "Spain",
    "code": "ES",
    "flag": "🇪🇸",
    "native": "España",
    "russian": "Испания",
    "phone": [
      34
    ],
    "continent": "EU",
    "capital": "Madrid",
    "currency": [
      "EUR"
    ],
    "languages": [
      "es",
      "eu",
      "ca",
      "gl",
      "oc"
    ],
    "both": "Spain (España)"
  },
  {
    "name": "Ethiopia",
    "code": "ET",
    "flag": "🇪🇹",
    "native": "ኢትዮጵያ",
    "russian": "Эфиопия",
    "phone": [
      251
    ],
    "continent": "AF",
    "capital": "Addis Ababa",
    "currency": [
      "ETB"
    ],
    "languages": [
      "am"
    ],
    "both": "Ethiopia (ኢትዮጵያ)"
  },
  {
    "name": "Finland",
    "code": "FI",
    "flag": "🇫🇮",
    "native": "Suomi",
    "russian": "Финляндия",
    "phone": [
      358
    ],
    "continent": "EU",
    "capital": "Helsinki",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fi",
      "sv"
    ],
    "both": "Finland (Suomi)"
  },
  {
    "name": "Fiji",
    "code": "FJ",
    "flag": "🇫🇯",
    "native": "Fiji",
    "russian": "Фиджи",
    "phone": [
      679
    ],
    "continent": "OC",
    "capital": "Suva",
    "currency": [
      "FJD"
    ],
    "languages": [
      "en",
      "fj",
      "hi",
      "ur"
    ],
    "both": "Fiji (Fiji)"
  },
  {
    "name": "Falkland Islands",
    "code": "FK",
    "flag": "🇫🇰",
    "native": "Falkland Islands",
    "russian": "Фолклендские острова",
    "phone": [
      500
    ],
    "continent": "SA",
    "capital": "Stanley",
    "currency": [
      "FKP"
    ],
    "languages": [
      "en"
    ],
    "both": "Falkland Islands (Falkland Islands)"
  },
  {
    "name": "Micronesia",
    "code": "FM",
    "flag": "🇫🇲",
    "native": "Micronesia",
    "russian": "Микронезия",
    "phone": [
      691
    ],
    "continent": "OC",
    "capital": "Palikir",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "Micronesia (Micronesia)"
  },
  {
    "name": "Faroe Islands",
    "code": "FO",
    "flag": "🇫🇴",
    "native": "Føroyar",
    "russian": "Фарерские острова",
    "phone": [
      298
    ],
    "continent": "EU",
    "capital": "Tórshavn",
    "currency": [
      "DKK"
    ],
    "languages": [
      "fo"
    ],
    "both": "Faroe Islands (Føroyar)"
  },
  {
    "name": "France",
    "code": "FR",
    "flag": "🇫🇷",
    "native": "France",
    "russian": "Франция",
    "phone": [
      33
    ],
    "continent": "EU",
    "capital": "Paris",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "France (France)"
  },
  {
    "name": "Gabon",
    "code": "GA",
    "flag": "🇬🇦",
    "native": "Gabon",
    "russian": "Габон",
    "phone": [
      241
    ],
    "continent": "AF",
    "capital": "Libreville",
    "currency": [
      "XAF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Gabon (Gabon)"
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "flag": "🇬🇧",
    "native": "United Kingdom",
    "russian": "Великобритания",
    "phone": [
      44
    ],
    "continent": "EU",
    "capital": "London",
    "currency": [
      "GBP"
    ],
    "languages": [
      "en"
    ],
    "both": "United Kingdom (United Kingdom)"
  },
  {
    "name": "Grenada",
    "code": "GD",
    "flag": "🇬🇩",
    "native": "Grenada",
    "russian": "Гренада",
    "phone": [
      1473
    ],
    "continent": "NA",
    "capital": "St. George's",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Grenada (Grenada)"
  },
  {
    "name": "Georgia",
    "code": "GE",
    "flag": "🇬🇪",
    "native": "საქართველო",
    "russian": "Грузия",
    "phone": [
      995
    ],
    "continent": "AS",
    "capital": "Tbilisi",
    "currency": [
      "GEL"
    ],
    "languages": [
      "ka"
    ],
    "both": "Georgia (საქართველო)"
  },
  {
    "name": "French Guiana",
    "code": "GF",
    "flag": "🇬🇫",
    "native": "Guyane française",
    "russian": "Французская Гвиана",
    "phone": [
      594
    ],
    "continent": "SA",
    "capital": "Cayenne",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "French Guiana (Guyane française)"
  },
  {
    "name": "Guernsey",
    "code": "GG",
    "flag": "🇬🇬",
    "native": "Guernsey",
    "russian": "Гернси",
    "phone": [
      44
    ],
    "continent": "EU",
    "capital": "St. Peter Port",
    "currency": [
      "GBP"
    ],
    "languages": [
      "en",
      "fr"
    ],
    "both": "Guernsey (Guernsey)"
  },
  {
    "name": "Ghana",
    "code": "GH",
    "flag": "🇬🇭",
    "native": "Ghana",
    "russian": "Гана",
    "phone": [
      233
    ],
    "continent": "AF",
    "capital": "Accra",
    "currency": [
      "GHS"
    ],
    "languages": [
      "en"
    ],
    "both": "Ghana (Ghana)"
  },
  {
    "name": "Gibraltar",
    "code": "GI",
    "flag": "🇬🇮",
    "native": "Gibraltar",
    "russian": "Гибралтар",
    "phone": [
      350
    ],
    "continent": "EU",
    "capital": "Gibraltar",
    "currency": [
      "GIP"
    ],
    "languages": [
      "en"
    ],
    "both": "Gibraltar (Gibraltar)"
  },
  {
    "name": "Greenland",
    "code": "GL",
    "flag": "🇬🇱",
    "native": "Kalaallit Nunaat",
    "russian": "Гренландия",
    "phone": [
      299
    ],
    "continent": "NA",
    "capital": "Nuuk",
    "currency": [
      "DKK"
    ],
    "languages": [
      "kl"
    ],
    "both": "Greenland (Kalaallit Nunaat)"
  },
  {
    "name": "Gambia",
    "code": "GM",
    "flag": "🇬🇲",
    "native": "Gambia",
    "russian": "Гамбия",
    "phone": [
      220
    ],
    "continent": "AF",
    "capital": "Banjul",
    "currency": [
      "GMD"
    ],
    "languages": [
      "en"
    ],
    "both": "Gambia (Gambia)"
  },
  {
    "name": "Guinea",
    "code": "GN",
    "flag": "🇬🇳",
    "native": "Guinée",
    "russian": "Гвинея",
    "phone": [
      224
    ],
    "continent": "AF",
    "capital": "Conakry",
    "currency": [
      "GNF"
    ],
    "languages": [
      "fr",
      "ff"
    ],
    "both": "Guinea (Guinée)"
  },
  {
    "name": "Guadeloupe",
    "code": "GP",
    "flag": "🇬🇵",
    "native": "Guadeloupe",
    "russian": "Гваделупа",
    "phone": [
      590
    ],
    "continent": "NA",
    "capital": "Basse-Terre",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Guadeloupe (Guadeloupe)"
  },
  {
    "name": "Equatorial Guinea",
    "code": "GQ",
    "flag": "🇬🇶",
    "native": "Guinea Ecuatorial",
    "russian": "Экваториальная Гвинея",
    "phone": [
      240
    ],
    "continent": "AF",
    "capital": "Malabo",
    "currency": [
      "XAF"
    ],
    "languages": [
      "es",
      "fr"
    ],
    "both": "Equatorial Guinea (Guinea Ecuatorial)"
  },
  {
    "name": "Greece",
    "code": "GR",
    "flag": "🇬🇷",
    "native": "Ελλάδα",
    "russian": "Греция",
    "phone": [
      30
    ],
    "continent": "EU",
    "capital": "Athens",
    "currency": [
      "EUR"
    ],
    "languages": [
      "el"
    ],
    "both": "Greece (Ελλάδα)"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "code": "GS",
    "flag": "🇬🇸",
    "native": "South Georgia",
    "russian": "Южная Георгия и Южные Сандвичевы острова",
    "phone": [
      500
    ],
    "continent": "AN",
    "capital": "King Edward Point",
    "currency": [
      "GBP"
    ],
    "languages": [
      "en"
    ],
    "both": "South Georgia and the South Sandwich Islands (South Georgia)"
  },
  {
    "name": "Guatemala",
    "code": "GT",
    "flag": "🇬🇹",
    "native": "Guatemala",
    "russian": "Гватемала",
    "phone": [
      502
    ],
    "continent": "NA",
    "capital": "Guatemala City",
    "currency": [
      "GTQ"
    ],
    "languages": [
      "es"
    ],
    "both": "Guatemala (Guatemala)"
  },
  {
    "name": "Guam",
    "code": "GU",
    "flag": "🇬🇺",
    "native": "Guam",
    "russian": "Гуам",
    "phone": [
      1671
    ],
    "continent": "OC",
    "capital": "Hagåtña",
    "currency": [
      "USD"
    ],
    "languages": [
      "en",
      "ch",
      "es"
    ],
    "both": "Guam (Guam)"
  },
  {
    "name": "Guinea-Bissau",
    "code": "GW",
    "flag": "🇬🇼",
    "native": "Guiné-Bissau",
    "russian": "Гвинея-Бисау",
    "phone": [
      245
    ],
    "continent": "AF",
    "capital": "Bissau",
    "currency": [
      "XOF"
    ],
    "languages": [
      "pt"
    ],
    "both": "Guinea-Bissau (Guiné-Bissau)"
  },
  {
    "name": "Guyana",
    "code": "GY",
    "flag": "🇬🇾",
    "native": "Guyana",
    "russian": "Гайана",
    "phone": [
      592
    ],
    "continent": "SA",
    "capital": "Georgetown",
    "currency": [
      "GYD"
    ],
    "languages": [
      "en"
    ],
    "both": "Guyana (Guyana)"
  },
  {
    "name": "Hong Kong",
    "code": "HK",
    "flag": "🇭🇰",
    "native": "香港",
    "russian": "Гонконг",
    "phone": [
      852
    ],
    "continent": "AS",
    "capital": "City of Victoria",
    "currency": [
      "HKD"
    ],
    "languages": [
      "zh",
      "en"
    ],
    "both": "Hong Kong (香港)"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "code": "HM",
    "flag": "🇭🇲",
    "native": "Heard Island and McDonald Islands",
    "russian": "Остров Херд и острова Макдональд",
    "phone": [
      61
    ],
    "continent": "AN",
    "capital": "",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Heard Island and McDonald Islands (Heard Island and McDonald Islands)"
  },
  {
    "name": "Honduras",
    "code": "HN",
    "flag": "🇭🇳",
    "native": "Honduras",
    "russian": "Гондурас",
    "phone": [
      504
    ],
    "continent": "NA",
    "capital": "Tegucigalpa",
    "currency": [
      "HNL"
    ],
    "languages": [
      "es"
    ],
    "both": "Honduras (Honduras)"
  },
  {
    "name": "Croatia",
    "code": "HR",
    "flag": "🇭🇷",
    "native": "Hrvatska",
    "russian": "Хорватия",
    "phone": [
      385
    ],
    "continent": "EU",
    "capital": "Zagreb",
    "currency": [
      "HRK"
    ],
    "languages": [
      "hr"
    ],
    "both": "Croatia (Hrvatska)"
  },
  {
    "name": "Haiti",
    "code": "HT",
    "flag": "🇭🇹",
    "native": "Haïti",
    "russian": "Гаити",
    "phone": [
      509
    ],
    "continent": "NA",
    "capital": "Port-au-Prince",
    "currency": [
      "HTG",
      "USD"
    ],
    "languages": [
      "fr",
      "ht"
    ],
    "both": "Haiti (Haïti)"
  },
  {
    "name": "Hungary",
    "code": "HU",
    "flag": "🇭🇺",
    "native": "Magyarország",
    "russian": "Венгрия",
    "phone": [
      36
    ],
    "continent": "EU",
    "capital": "Budapest",
    "currency": [
      "HUF"
    ],
    "languages": [
      "hu"
    ],
    "both": "Hungary (Magyarország)"
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "flag": "🇮🇩",
    "native": "Indonesia",
    "russian": "Индонезия",
    "phone": [
      62
    ],
    "continent": "AS",
    "capital": "Jakarta",
    "currency": [
      "IDR"
    ],
    "languages": [
      "id"
    ],
    "both": "Indonesia (Indonesia)"
  },
  {
    "name": "Ireland",
    "code": "IE",
    "flag": "🇮🇪",
    "native": "Éire",
    "russian": "Ирландия",
    "phone": [
      353
    ],
    "continent": "EU",
    "capital": "Dublin",
    "currency": [
      "EUR"
    ],
    "languages": [
      "ga",
      "en"
    ],
    "both": "Ireland (Éire)"
  },
  {
    "name": "Israel",
    "code": "IL",
    "flag": "🇮🇱",
    "native": "יִשְׂרָאֵל",
    "russian": "Израиль",
    "phone": [
      972
    ],
    "continent": "AS",
    "capital": "Jerusalem",
    "currency": [
      "ILS"
    ],
    "languages": [
      "he",
      "ar"
    ],
    "both": "Israel (יִשְׂרָאֵל)"
  },
  {
    "name": "Isle of Man",
    "code": "IM",
    "flag": "🇮🇲",
    "native": "Isle of Man",
    "russian": "Остров Мэн",
    "phone": [
      44
    ],
    "continent": "EU",
    "capital": "Douglas",
    "currency": [
      "GBP"
    ],
    "languages": [
      "en",
      "gv"
    ],
    "both": "Isle of Man (Isle of Man)"
  },
  {
    "name": "India",
    "code": "IN",
    "flag": "🇮🇳",
    "native": "भारत",
    "russian": "Индия",
    "phone": [
      91
    ],
    "continent": "AS",
    "capital": "New Delhi",
    "currency": [
      "INR"
    ],
    "languages": [
      "hi",
      "en"
    ],
    "both": "India (भारत)"
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "IO",
    "flag": "🇮🇴",
    "native": "British Indian Ocean Territory",
    "russian": "Британская территория в Индийском океане",
    "phone": [
      246
    ],
    "continent": "AS",
    "capital": "Diego Garcia",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "British Indian Ocean Territory (British Indian Ocean Territory)"
  },
  {
    "name": "Iraq",
    "code": "IQ",
    "flag": "🇮🇶",
    "native": "العراق",
    "russian": "Ирак",
    "phone": [
      964
    ],
    "continent": "AS",
    "capital": "Baghdad",
    "currency": [
      "IQD"
    ],
    "languages": [
      "ar",
      "ku"
    ],
    "both": "Iraq (العراق)"
  },
  {
    "name": "Iran",
    "code": "IR",
    "flag": "🇮🇷",
    "native": "ایران",
    "russian": "Иран",
    "phone": [
      98
    ],
    "continent": "AS",
    "capital": "Tehran",
    "currency": [
      "IRR"
    ],
    "languages": [
      "fa"
    ],
    "both": "Iran (ایران)"
  },
  {
    "name": "Iceland",
    "code": "IS",
    "flag": "🇮🇸",
    "native": "Ísland",
    "russian": "Исландия",
    "phone": [
      354
    ],
    "continent": "EU",
    "capital": "Reykjavik",
    "currency": [
      "ISK"
    ],
    "languages": [
      "is"
    ],
    "both": "Iceland (Ísland)"
  },
  {
    "name": "Italy",
    "code": "IT",
    "flag": "🇮🇹",
    "native": "Italia",
    "russian": "Италия",
    "phone": [
      39
    ],
    "continent": "EU",
    "capital": "Rome",
    "currency": [
      "EUR"
    ],
    "languages": [
      "it"
    ],
    "both": "Italy (Italia)"
  },
  {
    "name": "Jersey",
    "code": "JE",
    "flag": "🇯🇪",
    "native": "Jersey",
    "russian": "Джерси",
    "phone": [
      44
    ],
    "continent": "EU",
    "capital": "Saint Helier",
    "currency": [
      "GBP"
    ],
    "languages": [
      "en",
      "fr"
    ],
    "both": "Jersey (Jersey)"
  },
  {
    "name": "Jamaica",
    "code": "JM",
    "flag": "🇯🇲",
    "native": "Jamaica",
    "russian": "Ямайка",
    "phone": [
      1876
    ],
    "continent": "NA",
    "capital": "Kingston",
    "currency": [
      "JMD"
    ],
    "languages": [
      "en"
    ],
    "both": "Jamaica (Jamaica)"
  },
  {
    "name": "Jordan",
    "code": "JO",
    "flag": "🇯🇴",
    "native": "الأردن",
    "russian": "Иордания",
    "phone": [
      962
    ],
    "continent": "AS",
    "capital": "Amman",
    "currency": [
      "JOD"
    ],
    "languages": [
      "ar"
    ],
    "both": "Jordan (الأردن)"
  },
  {
    "name": "Japan",
    "code": "JP",
    "flag": "🇯🇵",
    "native": "日本",
    "russian": "Япония",
    "phone": [
      81
    ],
    "continent": "AS",
    "capital": "Tokyo",
    "currency": [
      "JPY"
    ],
    "languages": [
      "ja"
    ],
    "both": "Japan (日本)"
  },
  {
    "name": "Kenya",
    "code": "KE",
    "flag": "🇰🇪",
    "native": "Kenya",
    "russian": "Кения",
    "phone": [
      254
    ],
    "continent": "AF",
    "capital": "Nairobi",
    "currency": [
      "KES"
    ],
    "languages": [
      "en",
      "sw"
    ],
    "both": "Kenya (Kenya)"
  },
  {
    "name": "Kyrgyzstan",
    "code": "KG",
    "flag": "🇰🇬",
    "native": "Кыргызстан",
    "russian": "Киргизия",
    "phone": [
      996
    ],
    "continent": "AS",
    "capital": "Bishkek",
    "currency": [
      "KGS"
    ],
    "languages": [
      "ky",
      "ru"
    ],
    "both": "Kyrgyzstan (Кыргызстан)"
  },
  {
    "name": "Cambodia",
    "code": "KH",
    "flag": "🇰🇭",
    "native": "Kâmpŭchéa",
    "russian": "Камбоджа",
    "phone": [
      855
    ],
    "continent": "AS",
    "capital": "Phnom Penh",
    "currency": [
      "KHR"
    ],
    "languages": [
      "km"
    ],
    "both": "Cambodia (Kâmpŭchéa)"
  },
  {
    "name": "Kiribati",
    "code": "KI",
    "flag": "🇰🇮",
    "native": "Kiribati",
    "russian": "Кирибати",
    "phone": [
      686
    ],
    "continent": "OC",
    "capital": "South Tarawa",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Kiribati (Kiribati)"
  },
  {
    "name": "Comoros",
    "code": "KM",
    "flag": "🇰🇲",
    "native": "Komori",
    "russian": "Коморы",
    "phone": [
      269
    ],
    "continent": "AF",
    "capital": "Moroni",
    "currency": [
      "KMF"
    ],
    "languages": [
      "ar",
      "fr"
    ],
    "both": "Comoros (Komori)"
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "KN",
    "flag": "🇰🇳",
    "native": "Saint Kitts and Nevis",
    "russian": "Сент-Китс и Невис",
    "phone": [
      1869
    ],
    "continent": "NA",
    "capital": "Basseterre",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Saint Kitts and Nevis (Saint Kitts and Nevis)"
  },
  {
    "name": "North Korea",
    "code": "KP",
    "flag": "🇰🇵",
    "native": "북한",
    "russian": "Северная Корея",
    "phone": [
      850
    ],
    "continent": "AS",
    "capital": "Pyongyang",
    "currency": [
      "KPW"
    ],
    "languages": [
      "ko"
    ],
    "both": "North Korea (북한)"
  },
  {
    "name": "South Korea",
    "code": "KR",
    "flag": "🇰🇷",
    "native": "대한민국",
    "russian": "Южная Корея",
    "phone": [
      82
    ],
    "continent": "AS",
    "capital": "Seoul",
    "currency": [
      "KRW"
    ],
    "languages": [
      "ko"
    ],
    "both": "South Korea (대한민국)"
  },
  {
    "name": "Kuwait",
    "code": "KW",
    "flag": "🇰🇼",
    "native": "الكويت",
    "russian": "Кувейт",
    "phone": [
      965
    ],
    "continent": "AS",
    "capital": "Kuwait City",
    "currency": [
      "KWD"
    ],
    "languages": [
      "ar"
    ],
    "both": "Kuwait (الكويت)"
  },
  {
    "name": "Cayman Islands",
    "code": "KY",
    "flag": "🇰🇾",
    "native": "Cayman Islands",
    "russian": "Каймановы острова",
    "phone": [
      1345
    ],
    "continent": "NA",
    "capital": "George Town",
    "currency": [
      "KYD"
    ],
    "languages": [
      "en"
    ],
    "both": "Cayman Islands (Cayman Islands)"
  },
  {
    "name": "Laos",
    "code": "LA",
    "flag": "🇱🇦",
    "native": "ສປປລາວ",
    "russian": "Лаос",
    "phone": [
      856
    ],
    "continent": "AS",
    "capital": "Vientiane",
    "currency": [
      "LAK"
    ],
    "languages": [
      "lo"
    ],
    "both": "Laos (ສປປລາວ)"
  },
  {
    "name": "Lebanon",
    "code": "LB",
    "flag": "🇱🇧",
    "native": "لبنان",
    "russian": "Ливан",
    "phone": [
      961
    ],
    "continent": "AS",
    "capital": "Beirut",
    "currency": [
      "LBP"
    ],
    "languages": [
      "ar",
      "fr"
    ],
    "both": "Lebanon (لبنان)"
  },
  {
    "name": "Saint Lucia",
    "code": "LC",
    "flag": "🇱🇨",
    "native": "Saint Lucia",
    "russian": "Сент-Люсия",
    "phone": [
      1758
    ],
    "continent": "NA",
    "capital": "Castries",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Saint Lucia (Saint Lucia)"
  },
  {
    "name": "Liechtenstein",
    "code": "LI",
    "flag": "🇱🇮",
    "native": "Liechtenstein",
    "russian": "Лихтенштейн",
    "phone": [
      423
    ],
    "continent": "EU",
    "capital": "Vaduz",
    "currency": [
      "CHF"
    ],
    "languages": [
      "de"
    ],
    "both": "Liechtenstein (Liechtenstein)"
  },
  {
    "name": "Sri Lanka",
    "code": "LK",
    "flag": "🇱🇰",
    "native": "śrī laṃkāva",
    "russian": "Шри-Ланка",
    "phone": [
      94
    ],
    "continent": "AS",
    "capital": "Colombo",
    "currency": [
      "LKR"
    ],
    "languages": [
      "si",
      "ta"
    ],
    "both": "Sri Lanka (śrī laṃkāva)"
  },
  {
    "name": "Liberia",
    "code": "LR",
    "flag": "🇱🇷",
    "native": "Liberia",
    "russian": "Либерия",
    "phone": [
      231
    ],
    "continent": "AF",
    "capital": "Monrovia",
    "currency": [
      "LRD"
    ],
    "languages": [
      "en"
    ],
    "both": "Liberia (Liberia)"
  },
  {
    "name": "Lesotho",
    "code": "LS",
    "flag": "🇱🇸",
    "native": "Lesotho",
    "russian": "Лесото",
    "phone": [
      266
    ],
    "continent": "AF",
    "capital": "Maseru",
    "currency": [
      "LSL",
      "ZAR"
    ],
    "languages": [
      "en",
      "st"
    ],
    "both": "Lesotho (Lesotho)"
  },
  {
    "name": "Lithuania",
    "code": "LT",
    "flag": "🇱🇹",
    "native": "Lietuva",
    "russian": "Литва",
    "phone": [
      370
    ],
    "continent": "EU",
    "capital": "Vilnius",
    "currency": [
      "EUR"
    ],
    "languages": [
      "lt"
    ],
    "both": "Lithuania (Lietuva)"
  },
  {
    "name": "Luxembourg",
    "code": "LU",
    "flag": "🇱🇺",
    "native": "Luxembourg",
    "russian": "Люксембург",
    "phone": [
      352
    ],
    "continent": "EU",
    "capital": "Luxembourg",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr",
      "de",
      "lb"
    ],
    "both": "Luxembourg (Luxembourg)"
  },
  {
    "name": "Latvia",
    "code": "LV",
    "flag": "🇱🇻",
    "native": "Latvija",
    "russian": "Латвия",
    "phone": [
      371
    ],
    "continent": "EU",
    "capital": "Riga",
    "currency": [
      "EUR"
    ],
    "languages": [
      "lv"
    ],
    "both": "Latvia (Latvija)"
  },
  {
    "name": "Libya",
    "code": "LY",
    "flag": "🇱🇾",
    "native": "‏ليبيا",
    "russian": "Ливия",
    "phone": [
      218
    ],
    "continent": "AF",
    "capital": "Tripoli",
    "currency": [
      "LYD"
    ],
    "languages": [
      "ar"
    ],
    "both": "Libya (‏ليبيا)"
  },
  {
    "name": "Morocco",
    "code": "MA",
    "flag": "🇲🇦",
    "native": "المغرب",
    "russian": "Марокко",
    "phone": [
      212
    ],
    "continent": "AF",
    "capital": "Rabat",
    "currency": [
      "MAD"
    ],
    "languages": [
      "ar"
    ],
    "both": "Morocco (المغرب)"
  },
  {
    "name": "Monaco",
    "code": "MC",
    "flag": "🇲🇨",
    "native": "Monaco",
    "russian": "Монако",
    "phone": [
      377
    ],
    "continent": "EU",
    "capital": "Monaco",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Monaco (Monaco)"
  },
  {
    "name": "Moldova",
    "code": "MD",
    "flag": "🇲🇩",
    "native": "Moldova",
    "russian": "Молдова",
    "phone": [
      373
    ],
    "continent": "EU",
    "capital": "Chișinău",
    "currency": [
      "MDL"
    ],
    "languages": [
      "ro"
    ],
    "both": "Moldova (Moldova)"
  },
  {
    "name": "Montenegro",
    "code": "ME",
    "flag": "🇲🇪",
    "native": "Црна Гора",
    "russian": "Черногория",
    "phone": [
      382
    ],
    "continent": "EU",
    "capital": "Podgorica",
    "currency": [
      "EUR"
    ],
    "languages": [
      "sr",
      "bs",
      "sq",
      "hr"
    ],
    "both": "Montenegro (Црна Гора)"
  },
  {
    "name": "Saint Martin",
    "code": "MF",
    "flag": "🇲🇫",
    "native": "Saint-Martin",
    "russian": "Сен-Мартен",
    "phone": [
      590
    ],
    "continent": "NA",
    "capital": "Marigot",
    "currency": [
      "EUR"
    ],
    "languages": [
      "en",
      "fr",
      "nl"
    ],
    "both": "Saint Martin (Saint-Martin)"
  },
  {
    "name": "Madagascar",
    "code": "MG",
    "flag": "🇲🇬",
    "native": "Madagasikara",
    "russian": "Мадагаскар",
    "phone": [
      261
    ],
    "continent": "AF",
    "capital": "Antananarivo",
    "currency": [
      "MGA"
    ],
    "languages": [
      "fr",
      "mg"
    ],
    "both": "Madagascar (Madagasikara)"
  },
  {
    "name": "Marshall Islands",
    "code": "MH",
    "flag": "🇲🇭",
    "native": "M̧ajeļ",
    "russian": "Маршалловы острова",
    "phone": [
      692
    ],
    "continent": "OC",
    "capital": "Majuro",
    "currency": [
      "USD"
    ],
    "languages": [
      "en",
      "mh"
    ],
    "both": "Marshall Islands (M̧ajeļ)"
  },
  {
    "name": "North Macedonia",
    "code": "MK",
    "flag": "🇲🇰",
    "native": "Северна Македонија",
    "russian": "Северная Македония",
    "phone": [
      389
    ],
    "continent": "EU",
    "capital": "Skopje",
    "currency": [
      "MKD"
    ],
    "languages": [
      "mk"
    ],
    "both": "North Macedonia (Северна Македонија)"
  },
  {
    "name": "Mali",
    "code": "ML",
    "flag": "🇲🇱",
    "native": "Mali",
    "russian": "Мали",
    "phone": [
      223
    ],
    "continent": "AF",
    "capital": "Bamako",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Mali (Mali)"
  },
  {
    "name": "Myanmar [Burma]",
    "code": "MM",
    "flag": "🇲🇲",
    "native": "မြန်မာ",
    "russian": "Мьянма",
    "phone": [
      95
    ],
    "continent": "AS",
    "capital": "Naypyidaw",
    "currency": [
      "MMK"
    ],
    "languages": [
      "my"
    ],
    "both": "Myanmar [Burma] (မြန်မာ)"
  },
  {
    "name": "Mongolia",
    "code": "MN",
    "flag": "🇲🇳",
    "native": "Монгол улс",
    "russian": "Монголия",
    "phone": [
      976
    ],
    "continent": "AS",
    "capital": "Ulan Bator",
    "currency": [
      "MNT"
    ],
    "languages": [
      "mn"
    ],
    "both": "Mongolia (Монгол улс)"
  },
  {
    "name": "Macao",
    "code": "MO",
    "flag": "🇲🇴",
    "native": "澳門",
    "russian": "Макао",
    "phone": [
      853
    ],
    "continent": "AS",
    "capital": "",
    "currency": [
      "MOP"
    ],
    "languages": [
      "zh",
      "pt"
    ],
    "both": "Macao (澳門)"
  },
  {
    "name": "Northern Mariana Islands",
    "code": "MP",
    "flag": "🇲🇵",
    "native": "Northern Mariana Islands",
    "russian": "Северные Марианские острова",
    "phone": [
      1670
    ],
    "continent": "OC",
    "capital": "Saipan",
    "currency": [
      "USD"
    ],
    "languages": [
      "en",
      "ch"
    ],
    "both": "Northern Mariana Islands (Northern Mariana Islands)"
  },
  {
    "name": "Martinique",
    "code": "MQ",
    "flag": "🇲🇶",
    "native": "Martinique",
    "russian": "Мартиника",
    "phone": [
      596
    ],
    "continent": "NA",
    "capital": "Fort-de-France",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Martinique (Martinique)"
  },
  {
    "name": "Mauritania",
    "code": "MR",
    "flag": "🇲🇷",
    "native": "موريتانيا",
    "russian": "Мавритания",
    "phone": [
      222
    ],
    "continent": "AF",
    "capital": "Nouakchott",
    "currency": [
      "MRU"
    ],
    "languages": [
      "ar"
    ],
    "both": "Mauritania (موريتانيا)"
  },
  {
    "name": "Montserrat",
    "code": "MS",
    "flag": "🇲🇸",
    "native": "Montserrat",
    "russian": "Монтсеррат",
    "phone": [
      1664
    ],
    "continent": "NA",
    "capital": "Plymouth",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Montserrat (Montserrat)"
  },
  {
    "name": "Malta",
    "code": "MT",
    "flag": "🇲🇹",
    "native": "Malta",
    "russian": "Мальта",
    "phone": [
      356
    ],
    "continent": "EU",
    "capital": "Valletta",
    "currency": [
      "EUR"
    ],
    "languages": [
      "mt",
      "en"
    ],
    "both": "Malta (Malta)"
  },
  {
    "name": "Mauritius",
    "code": "MU",
    "flag": "🇲🇺",
    "native": "Maurice",
    "russian": "Маврикий",
    "phone": [
      230
    ],
    "continent": "AF",
    "capital": "Port Louis",
    "currency": [
      "MUR"
    ],
    "languages": [
      "en"
    ],
    "both": "Mauritius (Maurice)"
  },
  {
    "name": "Maldives",
    "code": "MV",
    "flag": "🇲🇻",
    "native": "Maldives",
    "russian": "Мальдивы",
    "phone": [
      960
    ],
    "continent": "AS",
    "capital": "Malé",
    "currency": [
      "MVR"
    ],
    "languages": [
      "dv"
    ],
    "both": "Maldives (Maldives)"
  },
  {
    "name": "Malawi",
    "code": "MW",
    "flag": "🇲🇼",
    "native": "Malawi",
    "russian": "Малави",
    "phone": [
      265
    ],
    "continent": "AF",
    "capital": "Lilongwe",
    "currency": [
      "MWK"
    ],
    "languages": [
      "en",
      "ny"
    ],
    "both": "Malawi (Malawi)"
  },
  {
    "name": "Mexico",
    "code": "MX",
    "flag": "🇲🇽",
    "native": "México",
    "russian": "Мексика",
    "phone": [
      52
    ],
    "continent": "NA",
    "capital": "Mexico City",
    "currency": [
      "MXN"
    ],
    "languages": [
      "es"
    ],
    "both": "Mexico (México)"
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "flag": "🇲🇾",
    "native": "Malaysia",
    "russian": "Малайзия",
    "phone": [
      60
    ],
    "continent": "AS",
    "capital": "Kuala Lumpur",
    "currency": [
      "MYR"
    ],
    "languages": [
      "ms"
    ],
    "both": "Malaysia (Malaysia)"
  },
  {
    "name": "Mozambique",
    "code": "MZ",
    "flag": "🇲🇿",
    "native": "Moçambique",
    "russian": "Мозамбик",
    "phone": [
      258
    ],
    "continent": "AF",
    "capital": "Maputo",
    "currency": [
      "MZN"
    ],
    "languages": [
      "pt"
    ],
    "both": "Mozambique (Moçambique)"
  },
  {
    "name": "Namibia",
    "code": "NA",
    "flag": "🇳🇦",
    "native": "Namibia",
    "russian": "Намибия",
    "phone": [
      264
    ],
    "continent": "AF",
    "capital": "Windhoek",
    "currency": [
      "NAD",
      "ZAR"
    ],
    "languages": [
      "en",
      "af"
    ],
    "both": "Namibia (Namibia)"
  },
  {
    "name": "New Caledonia",
    "code": "NC",
    "flag": "🇳🇨",
    "native": "Nouvelle-Calédonie",
    "russian": "Новая Каледония",
    "phone": [
      687
    ],
    "continent": "OC",
    "capital": "Nouméa",
    "currency": [
      "XPF"
    ],
    "languages": [
      "fr"
    ],
    "both": "New Caledonia (Nouvelle-Calédonie)"
  },
  {
    "name": "Niger",
    "code": "NE",
    "flag": "🇳🇪",
    "native": "Niger",
    "russian": "Нигер",
    "phone": [
      227
    ],
    "continent": "AF",
    "capital": "Niamey",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Niger (Niger)"
  },
  {
    "name": "Norfolk Island",
    "code": "NF",
    "flag": "🇳🇫",
    "native": "Norfolk Island",
    "russian": "Остров Норфолк",
    "phone": [
      672
    ],
    "continent": "OC",
    "capital": "Kingston",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Norfolk Island (Norfolk Island)"
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "flag": "🇳🇬",
    "native": "Nigeria",
    "russian": "Нигерия",
    "phone": [
      234
    ],
    "continent": "AF",
    "capital": "Abuja",
    "currency": [
      "NGN"
    ],
    "languages": [
      "en"
    ],
    "both": "Nigeria (Nigeria)"
  },
  {
    "name": "Nicaragua",
    "code": "NI",
    "flag": "🇳🇮",
    "native": "Nicaragua",
    "russian": "Никарагуа",
    "phone": [
      505
    ],
    "continent": "NA",
    "capital": "Managua",
    "currency": [
      "NIO"
    ],
    "languages": [
      "es"
    ],
    "both": "Nicaragua (Nicaragua)"
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "flag": "🇳🇱",
    "native": "Nederland",
    "russian": "Нидерланды",
    "phone": [
      31
    ],
    "continent": "EU",
    "capital": "Amsterdam",
    "currency": [
      "EUR"
    ],
    "languages": [
      "nl"
    ],
    "both": "Netherlands (Nederland)"
  },
  {
    "name": "Norway",
    "code": "NO",
    "flag": "🇳🇴",
    "native": "Norge",
    "russian": "Норвегия",
    "phone": [
      47
    ],
    "continent": "EU",
    "capital": "Oslo",
    "currency": [
      "NOK"
    ],
    "languages": [
      "no",
      "nb",
      "nn"
    ],
    "both": "Norway (Norge)"
  },
  {
    "name": "Nepal",
    "code": "NP",
    "flag": "🇳🇵",
    "native": "नपल",
    "russian": "Непал",
    "phone": [
      977
    ],
    "continent": "AS",
    "capital": "Kathmandu",
    "currency": [
      "NPR"
    ],
    "languages": [
      "ne"
    ],
    "both": "Nepal (नपल)"
  },
  {
    "name": "Nauru",
    "code": "NR",
    "flag": "🇳🇷",
    "native": "Nauru",
    "russian": "Науру",
    "phone": [
      674
    ],
    "continent": "OC",
    "capital": "Yaren",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en",
      "na"
    ],
    "both": "Nauru (Nauru)"
  },
  {
    "name": "Niue",
    "code": "NU",
    "flag": "🇳🇺",
    "native": "Niuē",
    "russian": "Ниуэ",
    "phone": [
      683
    ],
    "continent": "OC",
    "capital": "Alofi",
    "currency": [
      "NZD"
    ],
    "languages": [
      "en"
    ],
    "both": "Niue (Niuē)"
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "flag": "🇳🇿",
    "native": "New Zealand",
    "russian": "Новая Зеландия",
    "phone": [
      64
    ],
    "continent": "OC",
    "capital": "Wellington",
    "currency": [
      "NZD"
    ],
    "languages": [
      "en",
      "mi"
    ],
    "both": "New Zealand (New Zealand)"
  },
  {
    "name": "Oman",
    "code": "OM",
    "flag": "🇴🇲",
    "native": "عمان",
    "russian": "Оман",
    "phone": [
      968
    ],
    "continent": "AS",
    "capital": "Muscat",
    "currency": [
      "OMR"
    ],
    "languages": [
      "ar"
    ],
    "both": "Oman (عمان)"
  },
  {
    "name": "Panama",
    "code": "PA",
    "flag": "🇵🇦",
    "native": "Panamá",
    "russian": "Панама",
    "phone": [
      507
    ],
    "continent": "NA",
    "capital": "Panama City",
    "currency": [
      "PAB",
      "USD"
    ],
    "languages": [
      "es"
    ],
    "both": "Panama (Panamá)"
  },
  {
    "name": "Peru",
    "code": "PE",
    "flag": "🇵🇪",
    "native": "Perú",
    "russian": "Перу",
    "phone": [
      51
    ],
    "continent": "SA",
    "capital": "Lima",
    "currency": [
      "PEN"
    ],
    "languages": [
      "es"
    ],
    "both": "Peru (Perú)"
  },
  {
    "name": "French Polynesia",
    "code": "PF",
    "flag": "🇵🇫",
    "native": "Polynésie française",
    "russian": "Французская Полинезия",
    "phone": [
      689
    ],
    "continent": "OC",
    "capital": "Papeetē",
    "currency": [
      "XPF"
    ],
    "languages": [
      "fr"
    ],
    "both": "French Polynesia (Polynésie française)"
  },
  {
    "name": "Papua New Guinea",
    "code": "PG",
    "flag": "🇵🇬",
    "native": "Papua Niugini",
    "russian": "Папуа — Новая Гвинея",
    "phone": [
      675
    ],
    "continent": "OC",
    "capital": "Port Moresby",
    "currency": [
      "PGK"
    ],
    "languages": [
      "en"
    ],
    "both": "Papua New Guinea (Papua Niugini)"
  },
  {
    "name": "Philippines",
    "code": "PH",
    "flag": "🇵🇭",
    "native": "Pilipinas",
    "russian": "Филиппины",
    "phone": [
      63
    ],
    "continent": "AS",
    "capital": "Manila",
    "currency": [
      "PHP"
    ],
    "languages": [
      "en"
    ],
    "both": "Philippines (Pilipinas)"
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "flag": "🇵🇰",
    "native": "Pakistan",
    "russian": "Пакистан",
    "phone": [
      92
    ],
    "continent": "AS",
    "capital": "Islamabad",
    "currency": [
      "PKR"
    ],
    "languages": [
      "en",
      "ur"
    ],
    "both": "Pakistan (Pakistan)"
  },
  {
    "name": "Poland",
    "code": "PL",
    "flag": "🇵🇱",
    "native": "Polska",
    "russian": "Польша",
    "phone": [
      48
    ],
    "continent": "EU",
    "capital": "Warsaw",
    "currency": [
      "PLN"
    ],
    "languages": [
      "pl"
    ],
    "both": "Poland (Polska)"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "PM",
    "flag": "🇵🇲",
    "native": "Saint-Pierre-et-Miquelon",
    "russian": "Сен-Пьер и Микелон",
    "phone": [
      508
    ],
    "continent": "NA",
    "capital": "Saint-Pierre",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)"
  },
  {
    "name": "Pitcairn Islands",
    "code": "PN",
    "flag": "🇵🇳",
    "native": "Pitcairn Islands",
    "russian": "Острова Питкэрн",
    "phone": [
      64
    ],
    "continent": "OC",
    "capital": "Adamstown",
    "currency": [
      "NZD"
    ],
    "languages": [
      "en"
    ],
    "both": "Pitcairn Islands (Pitcairn Islands)"
  },
  {
    "name": "Puerto Rico",
    "code": "PR",
    "flag": "🇵🇷",
    "native": "Puerto Rico",
    "russian": "Пуэрто-Рико",
    "phone": [
      1787,
      1939
    ],
    "continent": "NA",
    "capital": "San Juan",
    "currency": [
      "USD"
    ],
    "languages": [
      "es",
      "en"
    ],
    "both": "Puerto Rico (Puerto Rico)"
  },
  {
    "name": "Palestine",
    "code": "PS",
    "flag": "🇵🇸",
    "native": "فلسطين",
    "russian": "Палестина",
    "phone": [
      970
    ],
    "continent": "AS",
    "capital": "Ramallah",
    "currency": [
      "ILS"
    ],
    "languages": [
      "ar"
    ],
    "both": "Palestine (فلسطين)"
  },
  {
    "name": "Palau",
    "code": "PW",
    "flag": "🇵🇼",
    "native": "Palau",
    "russian": "Палау",
    "phone": [
      680
    ],
    "continent": "OC",
    "capital": "Ngerulmud",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "Palau (Palau)"
  },
  {
    "name": "Paraguay",
    "code": "PY",
    "flag": "🇵🇾",
    "native": "Paraguay",
    "russian": "Парагвай",
    "phone": [
      595
    ],
    "continent": "SA",
    "capital": "Asunción",
    "currency": [
      "PYG"
    ],
    "languages": [
      "es",
      "gn"
    ],
    "both": "Paraguay (Paraguay)"
  },
  {
    "name": "Qatar",
    "code": "QA",
    "flag": "🇶🇦",
    "native": "قطر",
    "russian": "Катар",
    "phone": [
      974
    ],
    "continent": "AS",
    "capital": "Doha",
    "currency": [
      "QAR"
    ],
    "languages": [
      "ar"
    ],
    "both": "Qatar (قطر)"
  },
  {
    "name": "Réunion",
    "code": "RE",
    "flag": "🇷🇪",
    "native": "La Réunion",
    "russian": "Реюньон",
    "phone": [
      262
    ],
    "continent": "AF",
    "capital": "Saint-Denis",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Réunion (La Réunion)"
  },
  {
    "name": "Romania",
    "code": "RO",
    "flag": "🇷🇴",
    "native": "România",
    "russian": "Румыния",
    "phone": [
      40
    ],
    "continent": "EU",
    "capital": "Bucharest",
    "currency": [
      "RON"
    ],
    "languages": [
      "ro"
    ],
    "both": "Romania (România)"
  },
  {
    "name": "Serbia",
    "code": "RS",
    "flag": "🇷🇸",
    "native": "Србија",
    "russian": "Сербия",
    "phone": [
      381
    ],
    "continent": "EU",
    "capital": "Belgrade",
    "currency": [
      "RSD"
    ],
    "languages": [
      "sr"
    ],
    "both": "Serbia (Србија)"
  },
  {
    "name": "Rwanda",
    "code": "RW",
    "flag": "🇷🇼",
    "native": "Rwanda",
    "russian": "Руанда",
    "phone": [
      250
    ],
    "continent": "AF",
    "capital": "Kigali",
    "currency": [
      "RWF"
    ],
    "languages": [
      "rw",
      "en",
      "fr"
    ],
    "both": "Rwanda (Rwanda)"
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "flag": "🇸🇦",
    "native": "العربية السعودية",
    "russian": "Саудовская Аравия",
    "phone": [
      966
    ],
    "continent": "AS",
    "capital": "Riyadh",
    "currency": [
      "SAR"
    ],
    "languages": [
      "ar"
    ],
    "both": "Saudi Arabia (العربية السعودية)"
  },
  {
    "name": "Solomon Islands",
    "code": "SB",
    "flag": "🇸🇧",
    "native": "Solomon Islands",
    "russian": "Соломоновы острова",
    "phone": [
      677
    ],
    "continent": "OC",
    "capital": "Honiara",
    "currency": [
      "SBD"
    ],
    "languages": [
      "en"
    ],
    "both": "Solomon Islands (Solomon Islands)"
  },
  {
    "name": "Seychelles",
    "code": "SC",
    "flag": "🇸🇨",
    "native": "Seychelles",
    "russian": "Сейшелы",
    "phone": [
      248
    ],
    "continent": "AF",
    "capital": "Victoria",
    "currency": [
      "SCR"
    ],
    "languages": [
      "fr",
      "en"
    ],
    "both": "Seychelles (Seychelles)"
  },
  {
    "name": "Sudan",
    "code": "SD",
    "flag": "🇸🇩",
    "native": "السودان",
    "russian": "Судан",
    "phone": [
      249
    ],
    "continent": "AF",
    "capital": "Khartoum",
    "currency": [
      "SDG"
    ],
    "languages": [
      "ar",
      "en"
    ],
    "both": "Sudan (السودان)"
  },
  {
    "name": "Sweden",
    "code": "SE",
    "flag": "🇸🇪",
    "native": "Sverige",
    "russian": "Швеция",
    "phone": [
      46
    ],
    "continent": "EU",
    "capital": "Stockholm",
    "currency": [
      "SEK"
    ],
    "languages": [
      "sv"
    ],
    "both": "Sweden (Sverige)"
  },
  {
    "name": "Singapore",
    "code": "SG",
    "flag": "🇸🇬",
    "native": "Singapore",
    "russian": "Сингапур",
    "phone": [
      65
    ],
    "continent": "AS",
    "capital": "Singapore",
    "currency": [
      "SGD"
    ],
    "languages": [
      "en",
      "ms",
      "ta",
      "zh"
    ],
    "both": "Singapore (Singapore)"
  },
  {
    "name": "Saint Helena",
    "code": "SH",
    "flag": "🇸🇭",
    "native": "Saint Helena",
    "russian": "Святая Елена",
    "phone": [
      290
    ],
    "continent": "AF",
    "capital": "Jamestown",
    "currency": [
      "SHP"
    ],
    "languages": [
      "en"
    ],
    "both": "Saint Helena (Saint Helena)"
  },
  {
    "name": "Slovenia",
    "code": "SI",
    "flag": "🇸🇮",
    "native": "Slovenija",
    "russian": "Словения",
    "phone": [
      386
    ],
    "continent": "EU",
    "capital": "Ljubljana",
    "currency": [
      "EUR"
    ],
    "languages": [
      "sl"
    ],
    "both": "Slovenia (Slovenija)"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "code": "SJ",
    "flag": "🇸🇯",
    "native": "Svalbard og Jan Mayen",
    "russian": "Шпицберген и Ян-Майен",
    "phone": [
      4779
    ],
    "continent": "EU",
    "capital": "Longyearbyen",
    "currency": [
      "NOK"
    ],
    "languages": [
      "no"
    ],
    "both": "Svalbard and Jan Mayen (Svalbard og Jan Mayen)"
  },
  {
    "name": "Slovakia",
    "code": "SK",
    "flag": "🇸🇰",
    "native": "Slovensko",
    "russian": "Словакия",
    "phone": [
      421
    ],
    "continent": "EU",
    "capital": "Bratislava",
    "currency": [
      "EUR"
    ],
    "languages": [
      "sk"
    ],
    "both": "Slovakia (Slovensko)"
  },
  {
    "name": "Sierra Leone",
    "code": "SL",
    "flag": "🇸🇱",
    "native": "Sierra Leone",
    "russian": "Сьерра-Леоне",
    "phone": [
      232
    ],
    "continent": "AF",
    "capital": "Freetown",
    "currency": [
      "SLL"
    ],
    "languages": [
      "en"
    ],
    "both": "Sierra Leone (Sierra Leone)"
  },
  {
    "name": "San Marino",
    "code": "SM",
    "flag": "🇸🇲",
    "native": "San Marino",
    "russian": "Сан-Марино",
    "phone": [
      378
    ],
    "continent": "EU",
    "capital": "City of San Marino",
    "currency": [
      "EUR"
    ],
    "languages": [
      "it"
    ],
    "both": "San Marino (San Marino)"
  },
  {
    "name": "Senegal",
    "code": "SN",
    "flag": "🇸🇳",
    "native": "Sénégal",
    "russian": "Сенегал",
    "phone": [
      221
    ],
    "continent": "AF",
    "capital": "Dakar",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Senegal (Sénégal)"
  },
  {
    "name": "Somalia",
    "code": "SO",
    "flag": "🇸🇴",
    "native": "Soomaaliya",
    "russian": "Сомали",
    "phone": [
      252
    ],
    "continent": "AF",
    "capital": "Mogadishu",
    "currency": [
      "SOS"
    ],
    "languages": [
      "so",
      "ar"
    ],
    "both": "Somalia (Soomaaliya)"
  },
  {
    "name": "Suriname",
    "code": "SR",
    "flag": "🇸🇷",
    "native": "Suriname",
    "russian": "Суринам",
    "phone": [
      597
    ],
    "continent": "SA",
    "capital": "Paramaribo",
    "currency": [
      "SRD"
    ],
    "languages": [
      "nl"
    ],
    "both": "Suriname (Suriname)"
  },
  {
    "name": "South Sudan",
    "code": "SS",
    "flag": "🇸🇸",
    "native": "South Sudan",
    "russian": "Южный Судан",
    "phone": [
      211
    ],
    "continent": "AF",
    "capital": "Juba",
    "currency": [
      "SSP"
    ],
    "languages": [
      "en"
    ],
    "both": "South Sudan (South Sudan)"
  },
  {
    "name": "São Tomé and Príncipe",
    "code": "ST",
    "flag": "🇸🇹",
    "native": "São Tomé e Príncipe",
    "russian": "Сан-Томе и Принсипи",
    "phone": [
      239
    ],
    "continent": "AF",
    "capital": "São Tomé",
    "currency": [
      "STN"
    ],
    "languages": [
      "pt"
    ],
    "both": "São Tomé and Príncipe (São Tomé e Príncipe)"
  },
  {
    "name": "El Salvador",
    "code": "SV",
    "flag": "🇸🇻",
    "native": "El Salvador",
    "russian": "Сальвадор",
    "phone": [
      503
    ],
    "continent": "NA",
    "capital": "San Salvador",
    "currency": [
      "SVC",
      "USD"
    ],
    "languages": [
      "es"
    ],
    "both": "El Salvador (El Salvador)"
  },
  {
    "name": "Sint Maarten",
    "code": "SX",
    "flag": "🇸🇽",
    "native": "Sint Maarten",
    "russian": "Синт-Маартен",
    "phone": [
      1721
    ],
    "continent": "NA",
    "capital": "Philipsburg",
    "currency": [
      "ANG"
    ],
    "languages": [
      "nl",
      "en"
    ],
    "both": "Sint Maarten (Sint Maarten)"
  },
  {
    "name": "Syria",
    "code": "SY",
    "flag": "🇸🇾",
    "native": "سوريا",
    "russian": "Сирия",
    "phone": [
      963
    ],
    "continent": "AS",
    "capital": "Damascus",
    "currency": [
      "SYP"
    ],
    "languages": [
      "ar"
    ],
    "both": "Syria (سوريا)"
  },
  {
    "name": "Swaziland",
    "code": "SZ",
    "flag": "🇸🇿",
    "native": "Swaziland",
    "russian": "Свазиленд",
    "phone": [
      268
    ],
    "continent": "AF",
    "capital": "Lobamba",
    "currency": [
      "SZL"
    ],
    "languages": [
      "en",
      "ss"
    ],
    "both": "Swaziland (Swaziland)"
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "TC",
    "flag": "🇹🇨",
    "native": "Turks and Caicos Islands",
    "russian": "Теркс и Кайкос",
    "phone": [
      1649
    ],
    "continent": "NA",
    "capital": "Cockburn Town",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "Turks and Caicos Islands (Turks and Caicos Islands)"
  },
  {
    "name": "Chad",
    "code": "TD",
    "flag": "🇹🇩",
    "native": "Tchad",
    "russian": "Чад",
    "phone": [
      235
    ],
    "continent": "AF",
    "capital": "N'Djamena",
    "currency": [
      "XAF"
    ],
    "languages": [
      "fr",
      "ar"
    ],
    "both": "Chad (Tchad)"
  },
  {
    "name": "French Southern Territories",
    "code": "TF",
    "flag": "🇹🇫",
    "native": "Territoire des Terres australes et antarctiques fr",
    "russian": "Французские Южные и Антарктические территории",
    "phone": [
      262
    ],
    "continent": "AN",
    "capital": "Port-aux-Français",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "French Southern Territories (Territoire des Terres australes et antarctiques fr)"
  },
  {
    "name": "Togo",
    "code": "TG",
    "flag": "🇹🇬",
    "native": "Togo",
    "russian": "Того",
    "phone": [
      228
    ],
    "continent": "AF",
    "capital": "Lomé",
    "currency": [
      "XOF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Togo (Togo)"
  },
  {
    "name": "Thailand",
    "code": "TH",
    "flag": "🇹🇭",
    "native": "ประเทศไทย",
    "russian": "Таиланд",
    "phone": [
      66
    ],
    "continent": "AS",
    "capital": "Bangkok",
    "currency": [
      "THB"
    ],
    "languages": [
      "th"
    ],
    "both": "Thailand (ประเทศไทย)"
  },
  {
    "name": "Tajikistan",
    "code": "TJ",
    "flag": "🇹🇯",
    "native": "Тоҷикистон",
    "russian": "Таджикистан",
    "phone": [
      992
    ],
    "continent": "AS",
    "capital": "Dushanbe",
    "currency": [
      "TJS"
    ],
    "languages": [
      "tg",
      "ru"
    ],
    "both": "Tajikistan (Тоҷикистон)"
  },
  {
    "name": "Tokelau",
    "code": "TK",
    "flag": "🇹🇰",
    "native": "Tokelau",
    "russian": "Токелау",
    "phone": [
      690
    ],
    "continent": "OC",
    "capital": "Fakaofo",
    "currency": [
      "NZD"
    ],
    "languages": [
      "en"
    ],
    "both": "Tokelau (Tokelau)"
  },
  {
    "name": "East Timor",
    "code": "TL",
    "flag": "🇹🇱",
    "native": "Timor-Leste",
    "russian": "Восточный Тимор",
    "phone": [
      670
    ],
    "continent": "OC",
    "capital": "Dili",
    "currency": [
      "USD"
    ],
    "languages": [
      "pt"
    ],
    "both": "East Timor (Timor-Leste)"
  },
  {
    "name": "Turkmenistan",
    "code": "TM",
    "flag": "🇹🇲",
    "native": "Türkmenistan",
    "russian": "Туркменистан",
    "phone": [
      993
    ],
    "continent": "AS",
    "capital": "Ashgabat",
    "currency": [
      "TMT"
    ],
    "languages": [
      "tk",
      "ru"
    ],
    "both": "Turkmenistan (Türkmenistan)"
  },
  {
    "name": "Tunisia",
    "code": "TN",
    "flag": "🇹🇳",
    "native": "تونس",
    "russian": "Тунис",
    "phone": [
      216
    ],
    "continent": "AF",
    "capital": "Tunis",
    "currency": [
      "TND"
    ],
    "languages": [
      "ar"
    ],
    "both": "Tunisia (تونس)"
  },
  {
    "name": "Tonga",
    "code": "TO",
    "flag": "🇹🇴",
    "native": "Tonga",
    "russian": "Тонга",
    "phone": [
      676
    ],
    "continent": "OC",
    "capital": "Nuku'alofa",
    "currency": [
      "TOP"
    ],
    "languages": [
      "en",
      "to"
    ],
    "both": "Tonga (Tonga)"
  },
  {
    "name": "Turkey",
    "code": "TR",
    "flag": "🇹🇷",
    "native": "Türkiye",
    "russian": "Турция",
    "phone": [
      90
    ],
    "continent": "AS",
    "continents": [
      "AS",
      "EU"
    ],
    "capital": "Ankara",
    "currency": [
      "TRY"
    ],
    "languages": [
      "tr"
    ],
    "both": "Turkey (Türkiye)"
  },
  {
    "name": "Trinidad and Tobago",
    "code": "TT",
    "flag": "🇹🇹",
    "native": "Trinidad and Tobago",
    "russian": "Тринидад и Тобаго",
    "phone": [
      1868
    ],
    "continent": "NA",
    "capital": "Port of Spain",
    "currency": [
      "TTD"
    ],
    "languages": [
      "en"
    ],
    "both": "Trinidad and Tobago (Trinidad and Tobago)"
  },
  {
    "name": "Tuvalu",
    "code": "TV",
    "flag": "🇹🇻",
    "native": "Tuvalu",
    "russian": "Тувалу",
    "phone": [
      688
    ],
    "continent": "OC",
    "capital": "Funafuti",
    "currency": [
      "AUD"
    ],
    "languages": [
      "en"
    ],
    "both": "Tuvalu (Tuvalu)"
  },
  {
    "name": "Taiwan",
    "code": "TW",
    "flag": "🇹🇼",
    "native": "臺灣",
    "russian": "Тайвань",
    "phone": [
      886
    ],
    "continent": "AS",
    "capital": "Taipei",
    "currency": [
      "TWD"
    ],
    "languages": [
      "zh"
    ],
    "both": "Taiwan (臺灣)"
  },
  {
    "name": "Tanzania",
    "code": "TZ",
    "flag": "🇹🇿",
    "native": "Tanzania",
    "russian": "Танзания",
    "phone": [
      255
    ],
    "continent": "AF",
    "capital": "Dodoma",
    "currency": [
      "TZS"
    ],
    "languages": [
      "sw",
      "en"
    ],
    "both": "Tanzania (Tanzania)"
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "flag": "🇺🇦",
    "native": "Україна",
    "russian": "Украина",
    "phone": [
      380
    ],
    "continent": "EU",
    "capital": "Kyiv",
    "currency": [
      "UAH"
    ],
    "languages": [
      "uk"
    ],
    "both": "Ukraine (Україна)"
  },
  {
    "name": "Uganda",
    "code": "UG",
    "flag": "🇺🇬",
    "native": "Uganda",
    "russian": "Уганда",
    "phone": [
      256
    ],
    "continent": "AF",
    "capital": "Kampala",
    "currency": [
      "UGX"
    ],
    "languages": [
      "en",
      "sw"
    ],
    "both": "Uganda (Uganda)"
  },
  {
    "name": "U.S. Minor Outlying Islands",
    "code": "UM",
    "flag": "🇺🇲",
    "native": "United States Minor Outlying Islands",
    "russian": "США (Малые отдаленные острова)",
    "phone": [
      1
    ],
    "continent": "OC",
    "capital": "",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "U.S. Minor Outlying Islands (United States Minor Outlying Islands)"
  },
  {
    "name": "United States",
    "code": "US",
    "flag": "🇺🇸",
    "native": "United States",
    "russian": "США",
    "phone": [
      1
    ],
    "continent": "NA",
    "capital": "Washington D.C.",
    "currency": [
      "USD",
      "USN",
      "USS"
    ],
    "languages": [
      "en"
    ],
    "both": "United States (USA, United States of America)"
  },
  {
    "name": "Uruguay",
    "code": "UY",
    "flag": "🇺🇾",
    "native": "Uruguay",
    "russian": "Уругвай",
    "phone": [
      598
    ],
    "continent": "SA",
    "capital": "Montevideo",
    "currency": [
      "UYI",
      "UYU"
    ],
    "languages": [
      "es"
    ],
    "both": "Uruguay (Uruguay)"
  },
  {
    "name": "Uzbekistan",
    "code": "UZ",
    "flag": "🇺🇿",
    "native": "O‘zbekiston",
    "russian": "Узбекистан",
    "phone": [
      998
    ],
    "continent": "AS",
    "capital": "Tashkent",
    "currency": [
      "UZS"
    ],
    "languages": [
      "uz",
      "ru"
    ],
    "both": "Uzbekistan (O‘zbekiston)"
  },
  {
    "name": "Vatican City",
    "code": "VA",
    "flag": "🇻🇦",
    "native": "Vaticano",
    "russian": "Ватикан",
    "phone": [
      379
    ],
    "continent": "EU",
    "capital": "Vatican City",
    "currency": [
      "EUR"
    ],
    "languages": [
      "it",
      "la"
    ],
    "both": "Vatican City (Vaticano)"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "VC",
    "flag": "🇻🇨",
    "native": "Saint Vincent and the Grenadines",
    "russian": "Сент-Винсент и Гренадины",
    "phone": [
      1784
    ],
    "continent": "NA",
    "capital": "Kingstown",
    "currency": [
      "XCD"
    ],
    "languages": [
      "en"
    ],
    "both": "Saint Vincent and the Grenadines (Saint Vincent and the Grenadines)"
  },
  {
    "name": "Venezuela",
    "code": "VE",
    "flag": "🇻🇪",
    "native": "Venezuela",
    "russian": "Венесуэла",
    "phone": [
      58
    ],
    "continent": "SA",
    "capital": "Caracas",
    "currency": [
      "VES"
    ],
    "languages": [
      "es"
    ],
    "both": "Venezuela (Venezuela)"
  },
  {
    "name": "British Virgin Islands",
    "code": "VG",
    "flag": "🇻🇬",
    "native": "British Virgin Islands",
    "russian": "Виргинские острова (Великобритания)",
    "phone": [
      1284
    ],
    "continent": "NA",
    "capital": "Road Town",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "British Virgin Islands (British Virgin Islands)"
  },
  {
    "name": "U.S. Virgin Islands",
    "code": "VI",
    "flag": "🇻🇮",
    "native": "United States Virgin Islands",
    "russian": "Виргинские острова (США)",
    "phone": [
      1340
    ],
    "continent": "NA",
    "capital": "Charlotte Amalie",
    "currency": [
      "USD"
    ],
    "languages": [
      "en"
    ],
    "both": "U.S. Virgin Islands (United States Virgin Islands)"
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "flag": "🇻🇳",
    "native": "Việt Nam",
    "russian": "Вьетнам",
    "phone": [
      84
    ],
    "continent": "AS",
    "capital": "Hanoi",
    "currency": [
      "VND"
    ],
    "languages": [
      "vi"
    ],
    "both": "Vietnam (Việt Nam)"
  },
  {
    "name": "Vanuatu",
    "code": "VU",
    "flag": "🇻🇺",
    "native": "Vanuatu",
    "russian": "Вануату",
    "phone": [
      678
    ],
    "continent": "OC",
    "capital": "Port Vila",
    "currency": [
      "VUV"
    ],
    "languages": [
      "bi",
      "en",
      "fr"
    ],
    "both": "Vanuatu (Vanuatu)"
  },
  {
    "name": "Wallis and Futuna",
    "code": "WF",
    "flag": "🇼🇫",
    "native": "Wallis et Futuna",
    "russian": "Уоллис и Футуна",
    "phone": [
      681
    ],
    "continent": "OC",
    "capital": "Mata-Utu",
    "currency": [
      "XPF"
    ],
    "languages": [
      "fr"
    ],
    "both": "Wallis and Futuna (Wallis et Futuna)"
  },
  {
    "name": "Samoa",
    "code": "WS",
    "flag": "🇼🇸",
    "native": "Samoa",
    "russian": "Самоа",
    "phone": [
      685
    ],
    "continent": "OC",
    "capital": "Apia",
    "currency": [
      "WST"
    ],
    "languages": [
      "sm",
      "en"
    ],
    "both": "Samoa (Samoa)"
  },
  {
    "name": "Kosovo",
    "code": "XK",
    "flag": "🏴",
    "native": "Republika e Kosovës",
    "russian": "Косово",
    "phone": [
      377,
      381,
      383,
      386
    ],
    "continent": "EU",
    "capital": "Pristina",
    "currency": [
      "EUR"
    ],
    "languages": [
      "sq",
      "sr"
    ],
    "both": "Kosovo (Republika e Kosovës)"
  },
  {
    "name": "Yemen",
    "code": "YE",
    "flag": "🇾🇪",
    "native": "اليَمَن",
    "russian": "Йемен",
    "phone": [
      967
    ],
    "continent": "AS",
    "capital": "Sana'a",
    "currency": [
      "YER"
    ],
    "languages": [
      "ar"
    ],
    "both": "Yemen (اليَمَن)"
  },
  {
    "name": "Mayotte",
    "code": "YT",
    "flag": "🇾🇹",
    "native": "Mayotte",
    "russian": "Майотта",
    "phone": [
      262
    ],
    "continent": "AF",
    "capital": "Mamoudzou",
    "currency": [
      "EUR"
    ],
    "languages": [
      "fr"
    ],
    "both": "Mayotte (Mayotte)"
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "flag": "🇿🇦",
    "native": "South Africa",
    "russian": "Южная Африка",
    "phone": [
      27
    ],
    "continent": "AF",
    "capital": "Pretoria",
    "currency": [
      "ZAR"
    ],
    "languages": [
      "af",
      "en",
      "nr",
      "st",
      "ss",
      "tn",
      "ts",
      "ve",
      "xh",
      "zu"
    ],
    "both": "South Africa (South Africa)"
  },
  {
    "name": "Zambia",
    "code": "ZM",
    "flag": "🇿🇲",
    "native": "Zambia",
    "russian": "Замбия",
    "phone": [
      260
    ],
    "continent": "AF",
    "capital": "Lusaka",
    "currency": [
      "ZMW"
    ],
    "languages": [
      "en"
    ],
    "both": "Zambia (Zambia)"
  },
  {
    "name": "Zimbabwe",
    "code": "ZW",
    "flag": "🇿🇼",
    "native": "Zimbabwe",
    "russian": "Зимбабве",
    "phone": [
      263
    ],
    "continent": "AF",
    "capital": "Harare",
    "currency": [
      "USD",
      "ZAR",
      "BWP",
      "GBP",
      "AUD",
      "CNY",
      "INR",
      "JPY"
    ],
    "languages": [
      "en",
      "sn",
      "nd"
    ],
    "both": "Zimbabwe (Zimbabwe)"
  }
]
